import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
// 🟢 Import persistentLocalCache for better performance
import { initializeFirestore, persistentLocalCache, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBmbJBVTIgincEAFiVq9h1Pxv0tWDdKiRc",
  authDomain: "scoophype.co.za",
  projectId: "scoop-streetwear",
  storageBucket: "scoop-streetwear.firebasestorage.app",
  messagingSenderId: "595710947766",
  appId: "1:595710947766:web:43a348e8f10ca48ebcd117"
};


// Initialize Firebase safely
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);

// Firestore - connects directly to Firebase cloud servers
export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
  localCache: persistentLocalCache(),
});

export const storage = getStorage(app);

export const googleProvider = new GoogleAuthProvider();

googleProvider.addScope('profile');
googleProvider.addScope('email');
googleProvider.setCustomParameters({
  prompt: 'select_account'
});